"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ButtonGroupItem_1 = require("./ButtonGroupItem");
var utilities_1 = require("../../utilities");
var ButtonGroup = function (_a) {
    var attached = _a.attached, children = _a.children, className = _a.className, _b = _a.el, ButtonGroupElement = _b === void 0 ? 'div' : _b, fullWidth = _a.fullWidth, equalWidth = _a.equalWidth, props = __rest(_a, ["attached", "children", "className", "el", "fullWidth", "equalWidth"]);
    var ButtonGroupClasses = classnames_1.default('ButtonGroup', className, {
        'ButtonGroup--fullWidth': fullWidth,
        'ButtonGroup--equalWidth': fullWidth && equalWidth,
        'ButtonGroup--attached': attached,
    });
    return (react_1.default.createElement(ButtonGroupElement, __assign({ className: ButtonGroupClasses }, props),
        react_1.default.createElement(ButtonGroupElement, { className: "ButtonGroup__InternalWrapper" }, utilities_1.wrapChildren(children, ButtonGroupItem_1.ButtonGroupItem))));
};
exports.ButtonGroup = ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map